// Lazy placeholder – zobrazuje identitu vrstvy před načtením obsahu

interface NavigationLazyPlaceholderProps {
  readonly title: string;
}

/**
 * Placeholder pro lazy vrstvy před načtením komponenty.
 * Zobrazuje titulek z breadcrumb resolveru, takže identita vrstvy zůstává viditelná.
 */
export function NavigationLazyPlaceholder({ title }: NavigationLazyPlaceholderProps) {
  return (
    <div className="flex h-full items-center justify-center" data-testid="lazy-placeholder">
      <div className="text-muted-foreground space-y-2 text-center">
        <div className="text-lg font-medium">{title}</div>
        <div className="text-sm">Loading…</div>
      </div>
    </div>
  );
}
